/**
 * Resolve an agent/participant `avatarUrl` to something the browser can load.
 *
 * Avatars are served by the cowork backend at /assets/avatars/*.png. The
 * standalone app also shipped a copy in its own Vite public dir, so several
 * components short-circuited "/assets/…" paths and used them as-is —
 * local-first, one less cross-origin hop.
 *
 * omni-app has no such public copy, so that shortcut resolved against the app
 * origin and hit the SPA fallback: every avatar rendered as a broken image.
 * One helper now, so the next surface that shows an agent can't reintroduce it.
 */
import { API_BASE_URL } from './api/coworkApi';

export function avatarSrc(subject?: { avatarUrl?: string } | null): string | undefined {
  const url = subject?.avatarUrl;
  if (!url) return undefined;
  if (url.startsWith('http')) return url;
  return `${API_BASE_URL}${url}`;
}
